import {
  type EditorState,
  type EditorView,
} from '@progress/kendo-editor-common'
import { ProseMirror } from '@progress/kendo-react-editor'
import React from 'react'

import { exists } from '~/utils'

import { PopoverLink } from './PopoverLink'

const findAnchorElement = (
  node: Node | undefined,
): HTMLAnchorElement | undefined =>
  exists(node)
    ? exists((node as HTMLAnchorElement).href)
      ? (node as HTMLAnchorElement)
      : findAnchorElement(node.parentElement ?? undefined)
    : undefined

const getAnchorElement = (view: EditorView, state: EditorState) => {
  const node = view.domAtPos(state.selection.head).node

  return findAnchorElement(node)
}

export const popoverLinkPlugin = (
  onChange: (popoverLink: React.ReactNode) => void,
) =>
  new ProseMirror.Plugin({
    view: () => ({
      update: (view, prevState) => {
        const anchorElement = getAnchorElement(view, view.state)
        const prevAnchorElement = getAnchorElement(view, prevState)

        if (anchorElement !== prevAnchorElement) {
          onChange(
            exists(anchorElement) ? (
              <PopoverLink anchorElement={anchorElement} />
            ) : null,
          )
        }
      },
    }),
  })
